export default "__VITE_ASSET__BarusEKQ__"